import React from 'react';
import VisibleComp from '../components/visibleComponent.js';

import './about.scss';


export class About extends React.PureComponent{
    render(){
        return (<VisibleComp name="about" className='about'>
            <h2><em>Nice to meet you.</em></h2>
            <div className='moi'/>
            <div className='desc'>
                <p>Learning by doing — <em>that’s how I grow</em>. </p>
                <p>
                    As an IT engineering apprentice with nearly <em>three years</em> of professional experience, 
                    I apply my skills in real-world projects while exploring new technologies through personal experiments. 
                    Curiosity keeps me moving forward, one project at a time.
                </p>
            </div>
            </VisibleComp>)
    }
}